export default __webpack_public_path__ + "static/mobile-apps-image-3-bfe26b13e6ff9e5ef9fb6f6ad81974e8.png";